/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Counterparty_NameInputs */

const cs_contracts_counterparty_name = /** @type {(inputs: Contracts_Counterparty_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protistrana`)
};

const en_contracts_counterparty_name = /** @type {(inputs: Contracts_Counterparty_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Counterparty`)
};

/**
* | output |
* | --- |
* | "Counterparty" |
*
* @param {Contracts_Counterparty_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_counterparty_name = /** @type {((inputs?: Contracts_Counterparty_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Counterparty_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_counterparty_name(inputs)
	return cs_contracts_counterparty_name(inputs)
});